import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
    testid?: string;
};

export const MyFavoritesNoResults = ({ children, className = '', testid }: Props) => {
    return (
        <div
            className={cn(
                'ml-0 flex w-full flex-col items-center justify-center border-r border-b border-l border-border-success p-lg text-center',
                className
            )}
            data-testid={testid}
        >
            {children}
        </div>
    );
};
